import React from 'react';
import './meetusdiv.css'

import { useNavigate } from 'react-router-dom';

const Meetusdiv = (props) => {

    const navigate = useNavigate();

    return ( <>
    <div className='meetuscomp'>

        <h6 
            className='skip'
            onClick={() => navigate('/login')}
        >
            SKIP
        </h6>

        <div className='meetusdiv1'>
            <div className='muicon'>
                <img className='iconclass' src={props.muicon} alt="" />
            </div>

            <h6 className='discovertext'>{props.dicovertext}</h6>

            <p className='mup'>{props.mup}</p>

            <div className='slidediv'>
                <div className='slide1'></div>
                <div className='dot'></div>
                <div className='dot'></div>
                <div className='dot'></div>
            </div>

            
        </div>
    </div>
    </> );
}
 
export default Meetusdiv;